import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { Link } from "react-router-dom";
import { Container } from "react-bootstrap";
import PageTitle from '../common/PageTitleBanner';
import GoogleMapReact from 'google-map-react';
// import Map from '../common/Map';


const Contact = () => {
    const { register, formState: { errors }, handleSubmit } = useForm();
    const onSubmit = data => console.log(data);

    const [formData, setFormData] = useState({
        fullname: '',
        email: '',
        subject: '',
        message: ''
    });

    const inputChangeHandler = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        setFormData({ ...formData, [name]: value })
    }

    const formSubmitHandler = (e) => {
        e.preventDefault();
        console.log(formData);
    }

    const AnyReactComponent = ({ text }) => <div>{text}</div>;

    const defaultProps = {
        center: {
            lat: 59.95,
            lng: 30.33
        },
        zoom: 11
    };


    return (
        <>
            <PageTitle subtitle="Contact us" title="Get in touch" bannerImage="assets/images/banner.jpg" />
            <section className="content-section lightbg">
                <Container>
                    <div className="row">
                        <div className="col-md-8 offset-md-2 col-lg-6 offset-lg-3">
                            <div className="heading heading-md text-center mb-5">Get a quote!</div>
                            <div className="frm-holder">
                                <form onSubmit={handleSubmit(onSubmit)}>
                                    <div className="row">
                                        <div className="col-lg-6">
                                            <div className="form-group">
                                                <input type="text" placeholder="Name" className="form-control"  {...register("name", { required: true, maxLength: 30 })} />
                                                <span className='has-error'>
                                                    {errors.name?.type === 'required' && "Name is required"}
                                                    {errors.name?.type === 'maxLength' && "Subject line should not be greater than 30 words"}
                                                </span>
                                            </div>
                                        </div>
                                        <div className="col-lg-6">
                                            <div className="form-group">
                                                <input type="email" placeholder="Email ID" className="form-control" {...register("email", { required: true, pattern: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i })} />
                                                <span className='has-error'>
                                                    {errors.email?.type === 'required' && "Email is required"}
                                                    {errors.email?.type === 'pattern' && "Invalied Email Id."}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <input type="text" placeholder="Subject" className="form-control" {...register("subject", { required: true, maxLength: 100 })} />
                                        <span className='has-error'>
                                            {errors.subject?.type === 'required' && "Subject is required"}
                                            {errors.subject?.type === 'maxLength' && "Subject line should not be greater than 100 words"}
                                        </span>
                                    </div>
                                    <div className="form-group">
                                        <textarea placeholder="Message" className="form-control" {...register("message", { required: true, maxLength: 1000 })} />
                                        <span className='has-error'>
                                            {errors.message?.type === 'required' && "Message is required"}
                                        </span>
                                    </div>
                                    <div className="frm-submit mt-4 text-center">
                                        <input type="submit" value="Submit" className="button" />
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </Container>
            </section>
            <section className="content-section">
                <Container className="container">
                    <div className="row">
                        <div className="col-lg-6">
                            <div className="contact-info">
                                <ul>
                                    <li>
                                        <i className="fas fa-envelope-open-text"></i>
                                        <small>Email: </small>
                                        <Link to="mailto:info@rudrastructural.org">info@rudrass.in</Link>
                                    </li>
                                    <li>
                                        <i className="fas fa-phone-volume"></i>
                                        <small>Phone: </small>
                                        +91-9473525535, +91-8849299890
                                    </li>
                                    <li>
                                        <i className="fas fa-map-marked-alt"></i>
                                        <small>Address: </small>
                                        2nd  Floor, <br />204 House No<br />2H Vasind, Thane(Mumbai)- 421601
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="map embed-responsive embed-responsive-21by9 tab-top-spacing">
                                {/* <Map /> */}
                                {/* <iframe className="embed-responsive-item" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3984.8476584607665!2d101.73279121463501!3d2.860311155658276!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31cdc81555555555%3A0xb52428f2aa3be4cd!2sRudra%20Structural%20Services!5e0!3m2!1sen!2sin!4v1627640053112!5m2!1sen!2sin" width="100%" height="315" style={{ border: 0 }} loading="lazy"></iframe> */}
                                <div style={{ height: '100vh', width: '100%' }}>
                                    <GoogleMapReact
                                        bootstrapURLKeys={{ key: 'AIzaSyDWtpRc9n0nIa-UOz83os0B-0hHn-jt_LA' }}
                                        defaultCenter={defaultProps.center}
                                        defaultZoom={defaultProps.zoom}
                                    >
                                        <AnyReactComponent
                                            lat={59.955413}
                                            lng={30.337844}
                                            text="My Marker"
                                        />
                                    </GoogleMapReact>
                                </div>
                            </div>
                        </div>
                    </div>
                </Container>
            </section>
        </>
    )
}
export default Contact;